import React from "react";
import ProfileImg from "assets/profile_img.jpg";
import SocialButtons from "components/social-buttons";
import { CVButton } from "styles/home";
import { IoPhonePortraitOutline } from "react-icons/io5";
import { MdAlternateEmail } from "react-icons/md";
import { FaLocationDot } from "react-icons/fa6";
import { FaTelegramPlane } from "react-icons/fa";

const ProfileCard = () => {
  return (
    <div>
      <div className="personal-info-container">
        <img className="profile-img" src={ProfileImg} alt="profile-image" />
        <h3>Ilyosjon Inomjonov</h3>
        <h4>Software Engineer</h4>
        <div>
          <SocialButtons />
        </div>
        <div className="home-contact-container">
          <p className="line">
            <IoPhonePortraitOutline size={20} className="contact-icon" />
            +821082547679
          </p>
          <a className="line" href="mailto:inomjonov.dev@gmail.com">
            <MdAlternateEmail size={20} className="contact-icon" />
            inomjonov.dev@gmail.com
          </a>
          <p className="line">
            {" "}
            <FaLocationDot size={20} className="contact-icon" />
            Seoul, South Korea
          </p>
          <a className="line" href="https://t.me/unbemon">
            <FaTelegramPlane size={20} className="contact-icon" />
            https://t.me/unbemon
          </a>
        </div>
        <CVButton
          href="https://drive.google.com/file/d/1TA0uwK4Ttgz1iMsYhI7vLRRU-Zdcwer3/view?usp=sharing"
          target="_blank"
          $bg="#C2B293"
          $border="var(--color-brown-border)"
        >
          View Resume
        </CVButton>
      </div>
    </div>
  );
};

export default ProfileCard;
